import type { ChangeEvent } from 'react';
import { FormControlLabel, FormGroup, Switch } from '@mui/material';
import { useCatalogFilters } from '@/packages/courses/context/catalog-filters';
import type { FilterSchemaSwitch } from '@/packages/courses/types/schema';
import type { CatalogUrlKey } from '@/packages/courses/types/url-params';
import { catalogUrlKeys } from '@/packages/courses/types/url-params';

interface FilterSwitchProps extends FilterSchemaSwitch {
  id: CatalogUrlKey;
}

export const FilterSwitch = ({ id, label }: FilterSwitchProps) => {
  const { params, actions } = useCatalogFilters();

  const isFreeCourses = id === catalogUrlKeys.free_courses;
  const hasFreeCoursesParam = params[id]?.[0] === 'true';
  const hasPriceMaxZero = params.price_max?.[0] === '0';

  const checked = isFreeCourses
    ? hasFreeCoursesParam || hasPriceMaxZero
    : params[id]?.[0] === 'true';

  const handleChange = (
    _: ChangeEvent<HTMLInputElement>,
    value: boolean
  ) => {
    if (isFreeCourses && !value) {
      actions.reset([id, 'price_max', 'price_min']);
    } else {
      actions.setParam(id, value ? ['true'] : undefined);
    }
  };

  return (
    <FormGroup>
      <FormControlLabel
        control={<Switch checked={checked} onChange={handleChange} />}
        label={label}
      />
    </FormGroup>
  );
};
